import React from 'react';
//import { Link } from 'react-router-dom';
function LayoutFooter() {
  	return (
		<footer className='fww-adn-footer'>
			Copyright ⓒ 2024 대·중소기업·농어업협력재단. All Rights Reserved.
		</footer>
	);
}

export default LayoutFooter;